import { Component, OnInit ,ViewChild} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import axios from 'axios';

@Component({
  selector: 'app-report-disman-area-lv',
  templateUrl: './report-disman-area-lv.component.html',
  styleUrls: ['./report-disman-area-lv.component.css']
})
export class ReportDismanAreaLvComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  datagoup:UntypedFormGroup;
  constructor() { 
    this.datagoup = new UntypedFormGroup({
      szone:new UntypedFormControl(0),
      today:new UntypedFormControl(),
    });
    
  }

  ngOnInit(): void {
    this.LoadZone();
    this.LoadsupcodeData();
    this.LoadgroupData();
  }

  @ViewChild('zonetruck', {static:false}) dataTable:any;

  zonecode:any;
  LoadZone(){
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
    .then(res =>{      
      this.zonecode = (res.data.recordset);
    }).catch(err => { throw(err)})

  }

  displayedColumns = ['Code','Codename','areaDs','difareaDsf','arealv1','arealv2','arealv3','arealv4','arealv5'];


  allSupcode:any;
  allGroupcode:any; 

  Dataalltruck:any;
/*  
  countdata:Array<number>=[0,0,0,0];
  sumdata:Array<number>=[0,0,0,0,0];
*/
  LoadgroupData(){
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[dbo].[v_sumArealv_groupCode]&w=1=1";
    axios.get(url)
    .then(res =>{
      if(res.data.rowsAffected[0] >= 1){
        let data = (res.data.recordset);
        this.allGroupcode = data;

      }
    }).catch(err => { throw(err)})
  }
  
  LoadsupcodeData(){
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[dbo].[v_sumArealv_supCode]&w=1=1";
    axios.get(url)
    .then(res =>{
      if(res.data.rowsAffected[0] >= 1){
        let data = (res.data.recordset);
        this.allSupcode = data;
      /*  this.carCutT1 = data.filter(el => el.check_cut == 1)
        this.carCutT2 = data.filter(el => el.check_cut == 2)
        this.carCutT3 = data.filter(el => el.check_cut == 3)
        this.countdata = [this.allSupcode.length,this.carCutT1.length,this.carCutT2.length,this.carCutT3.length]
        this.sumdata = [
          (data.map((el:any) => {return parseFloat(el.canCutMax)})).reduce((a, b) => a + b, 0),
          (data.map((el:any) => {return parseFloat(el.target_cane)})).reduce((a, b) => a + b, 0),
          (data.map((el:any) => {return parseFloat(el.sum_wgt)})).reduce((a, b) => a + b, 0),
          (data.map((el:any) => {return parseFloat(el.canPerDay)})).reduce((a, b) => a + b, 0),
          (data.map((el:any) => {return parseFloat(el.sum_wgt24h)})).reduce((a, b) => a + b, 0)
        ]*/
        this.setDataTeble(0);
       /* 
        console.log('countdata',this.countdata);
        console.log('sumdata',this.sumdata);
        */
      }
      setTimeout(() => {
        $(this.dataTable.nativeElement).DataTable();
      }, 100);
    }).catch(err => { throw(err)})
  }


  typec:string
  settap:number; txtTap:string
  lastsum:any;

  setDataTeble(i=0){
    
    let dataistable
    let numf = 15
    let zcode  = this.datagoup.get('szone').value;
    let ndData

    if(i == 0){//all
      this.settap=i
      dataistable = this.allSupcode
      this.txtTap = 'อิงตามนักส่งเสริม';
      numf = 20;
      this.datagoup.controls['szone'].reset;
    }
    else if(i == 1){//
      this.settap=i
      dataistable = this.allGroupcode;
      this.txtTap = 'อิงตามกลุ่มตัด';
      numf = 50;
      this.datagoup.controls['szone'].reset;
    }
    else if(i == 10){//
      if(this.settap == 0)ndData = this.allSupcode
      else if(this.settap == 1)ndData = this.allGroupcode;
      /// -------------
      if(zcode.substring(0,1)=='P'){
        dataistable = ndData.filter((el:any)=> el.Partcode === zcode);
      }
      else  if(zcode === 'All'){
        dataistable = ndData;
      }
      else {
        dataistable = ndData.filter((el:any)=> el.supzone === zcode);
      }
      
      //this.txtTap = 'อิงตามกลุ่มตัด';
      numf = dataistable.length;
    }  

    if(dataistable != null){
      this.Dataalltruck =  new MatTableDataSource(dataistable);
      this.paginator.length = dataistable.length;
      this.paginator.pageSize = numf;
      this.Dataalltruck.paginator = this.paginator;
      this.Dataalltruck.sort = this.sort;   
      console.log('dataistable',dataistable);
      if(i == 0 || i == 1) this.lastsum = dataistable.filter(el => el.Code === 'BRD');
    }
    console.log('data',i,dataistable.length);
    console.log('lastsum',this.lastsum);   
    
  }
  filterSelectObj = [];
  
  resetFilters() {
    //this.filterValues = {}
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
    })
    this.Dataalltruck.filter = "";
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.Dataalltruck.filter = filterValue.trim().toLowerCase();
    if (this.Dataalltruck.paginator) {
      this.Dataalltruck.paginator.firstPage();
    }
    console.log('Dataalltruck.filter',this.Dataalltruck.filter) 
  }

  anyFilter() {
    let zone  = this.datagoup.get('szone').value;
    const tableFilters = [];
    tableFilters.push({
      id: 'Code',
      value: zone
    });
    this.Dataalltruck.filter = JSON.stringify(tableFilters).trim().toLowerCase();;
    if (this.Dataalltruck.paginator) {
      this.Dataalltruck.paginator.firstPage();
    }
    console.log('this', zone , tableFilters);
  }
}
